// extracted by mini-css-extract-plugin
module.exports = {"select":"Select__select__sjp5b","labelInput":"Select__labelInput__ayM16"};